import { isMobile } from '@dynamic-labs/utils';
import { LAST_USED_WALLET } from '../../../../utils/constants/localStorage.js';
import '../../../../utils/constants/colors.js';
import { getFromLS } from '../storage/getFromLS.js';
import '../../../../config/LSSuffix.js';

const comingSoonToMultiWalletMobile = ['Coinbase', 'MyAlgo', 'Braavos'];
const comingSoonToMultiWalletDesktop = ['MyAlgo'];
const getWalletListItemLabel = ({ walletName, usingMultiWallet, isInstalledOnBrowser, }) => {
    let label;
    const isComingSoon = usingMultiWallet &&
        ((isMobile() && comingSoonToMultiWalletMobile.includes(walletName)) ||
            (!isMobile() && comingSoonToMultiWalletDesktop.includes(walletName)));
    const lastUsed = getFromLS(LAST_USED_WALLET) === walletName;
    if (isComingSoon) {
        label = 'Coming soon';
    }
    else if (lastUsed) {
        label = 'Last used';
    }
    else if (isInstalledOnBrowser) {
        label = 'Installed';
    }
    return label;
};

export { getWalletListItemLabel };
